import { render, staticRenderFns } from "./NightOrderModal.vue?vue&type=template&id=22f13212&scoped=true"
import script from "./NightOrderModal.vue?vue&type=script&lang=js"
export * from "./NightOrderModal.vue?vue&type=script&lang=js"
import style0 from "./NightOrderModal.vue?vue&type=style&index=0&id=22f13212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f13212",
  null
  
)

export default component.exports